import { SVGProps } from "react";

export const IconBad = ({ width = 64, height = 64, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 64 64"
    fill="none"
    {...props}
  >
    <path
      fill="#BECDE6"
      d="M56.259 28.183c-2.367-2.516-5.477-3.943-8.787-3.979h-1.125l-.248-1.195c-.662-3.104-2.317-5.923-4.65-7.939-2.4-2.051-5.295-3.122-8.357-3.068-3.11.053-5.99 1.213-8.356 3.39-2.3 2.105-3.873 5.03-4.419 8.206l-.248 1.463-1.373-.232c-.795-.125-1.506-.197-2.185-.179-3.375.054-6.552 1.517-8.919 4.14-2.366 2.622-3.64 6.065-3.59 9.722.049 3.639 1.406 7.064 3.838 9.615 2.433 2.551 5.627 3.925 9.019 3.871l30.63-.445c3.375-.054 6.553-1.517 8.919-4.14 2.366-2.622 3.64-6.083 3.59-9.722-.049-3.586-1.373-6.94-3.723-9.49l-.016-.018Z"
    />
    <path
      fill="#819FCF"
      d="M7.84 48.095C5.406 45.522 4.05 42.068 4 38.398c3.84 5.297 22.8 9.298 34-.398 11.2 4.152 18.408-3.796 18.275-10 2.35 2.573 3.674 5.955 3.724 9.57.05 3.67-1.225 7.16-3.591 9.805-2.367 2.645-5.544 4.12-8.92 4.174l-30.63.45c-3.393.053-6.586-1.332-9.019-3.904Z"
    />
    <path
      stroke="#3F4A61"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M56.259 28.183c-2.367-2.516-5.477-3.943-8.787-3.979h-1.125l-.248-1.195c-.662-3.104-2.317-5.923-4.65-7.939-2.4-2.051-5.295-3.122-8.357-3.068-3.11.053-5.99 1.213-8.356 3.39-2.3 2.105-3.873 5.03-4.419 8.206l-.248 1.463-1.373-.232c-.795-.125-1.506-.197-2.185-.179-3.375.054-6.552 1.517-8.919 4.14-2.366 2.622-3.64 6.065-3.59 9.722.049 3.639 1.406 7.064 3.838 9.615a12.355 12.355 0 0 0 9.019 3.871l30.63.002c3.375-.053 6.553-1.964 8.919-4.586 2.366-2.623 3.64-6.084 3.59-9.723-.049-3.586-1.373-6.94-3.723-9.49l-.016-.018Z"
    />
  </svg>
);
